import React, { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import Select from 'react-select';
import { toast } from 'react-toastify';
import AppNavbar from "./AppNavbar"

const UserCreate = () => {
    const navigate = useNavigate();

    const [userData, setUserData] = useState({
        name: "",
        mobile_number: "",
        city_id: "",
        email: "",
        role: "user",
        password: "",
        status: 1
    });

    const [confirmPassword, setConfirmPassword] = useState('');
    const [loading, setLoading] = useState(false);
    const [dropdownOptions, setDropdownOptions] = useState([]);
    //const [userRole, setUserRole] = useState(null);

    useEffect(() => {
        // Check if user is logged in and is admin
        const loginData = localStorage.getItem('login');
        if (loginData) {
            try {
                const user = JSON.parse(loginData);
                //  setUserRole(user.role);
                if (user.role !== 'admin') {
                    toast.error('Access denied. Admin only.');
                    navigate('/');
                }
            } catch (error) {
                navigate('/login');
            }
        } else {
            navigate('/login');
        }

        // Fetch cities for dropdown
        const fetchData = async () => {
            try {
                const response = await fetch(
                    'https://hospital.rozeetechnist.com/hospital-api/getCities.php'
                );
                const result = await response.json();
                setDropdownOptions(result);
            } catch (error) {
                console.error('Error fetching data:', error);
            }
        };

        fetchData();
    }, [navigate]);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setUserData(prevData => ({
            ...prevData,
            [name]: value,
        }));
    };

    const handleCityChange = (selectedOption) => {
        setUserData((prevData) => ({
            ...prevData,
            city_id: selectedOption ? selectedOption.value : '',
        }));
    };

    const handleRoleChange = (e) => {
        setUserData(prevData => ({
            ...prevData,
            role: e.target.value,
        }));
    };

    const handleStatusChange = (e) => {
        setUserData(prevData => ({
            ...prevData,
            status: e.target.value === '1' ? 1 : 0,
        }));
    };

    const handleCreate = () => {
        // Validation
        if (!userData.name.trim()) {
            toast.error('Please enter Name');
            return;
        }
        if (!userData.mobile_number.trim()) {
            toast.error('Please enter Mobile Number');
            return;
        }
        if (userData.mobile_number.length !== 10) {
            toast.error('Mobile number must be 10 digits');
            return;
        }
        if (!userData.city_id) {
            toast.error('Please select City');
            return;
        }
        if (!userData.password) {
            toast.error('Please enter Password');
            return;
        }
        if (userData.password.length < 6) {
            toast.error('Password must be at least 6 characters');
            return;
        }
        if (userData.password !== confirmPassword) {
            toast.error('Passwords do not match');
            return;
        }

        setLoading(true);

        // Prepare data for API
        const apiData = {
            name: userData.name,
            mobile_number: userData.mobile_number,
            city_id: userData.city_id,
            password: userData.password,
            role: userData.role,
            status: userData.status
        };

        // Add email if provided
        if (userData.email && userData.email.trim()) {
            apiData.email = userData.email.trim();
        }

        fetch("https://hospital.rozeetechnist.com/hospital-api/createUser.php", {
            method: "Post",
            headers: {
                "Content-Type": "application/json"
            },
            body: JSON.stringify(apiData)
        }).then((result) => {
            result.json().then((resp) => {
                if (resp.status) {
                    setLoading(false);
                    toast.success(resp.message);
                    navigate("/user-list");
                } else {
                    toast.error(resp.message);
                    setLoading(false);
                }
            })
        }).catch((error) => {
            console.error('Error creating user:', error);
            toast.error('An error occurred. Please try again.');
            setLoading(false);
        });
    }

    return (
        <div>
            <AppNavbar />
            <div className="container">
                <div className="row top-page-bar">
                    <div className="col-9">
                        <div className="main-title">
                            <h1>Add New User</h1>
                        </div>
                    </div>
                    <div className="col-3">
                        <div className="search-area">
                            <div className="buttons">
                                <Link className='btn btn-secondary' to="/user-list">Back</Link>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="container">
                <div className="row g-3">
                    <div className="col-md-6">
                        <label className="form-label">Name <span className="text-danger">*</span></label>
                        <input
                            className="form-control"
                            value={userData.name}
                            name="name"
                            onChange={handleChange}
                            placeholder="Enter name"
                            required
                        />
                    </div>

                    <div className="col-md-6">
                        <label className="form-label">Mobile Number <span className="text-danger">*</span></label>
                        <input
                            className="form-control"
                            value={userData.mobile_number}
                            name="mobile_number"
                            onChange={handleChange}
                            placeholder="Enter 10 digit mobile number"
                            maxLength="10"
                            pattern="[0-9]{10}"
                            required
                        />
                    </div>

                    <div className="col-md-6">
                        <label className="form-label">City <span className="text-danger">*</span></label>
                        <Select
                            value={dropdownOptions.find(option => option.value === userData.city_id) || null}
                            name="city_id"
                            onChange={handleCityChange}
                            options={dropdownOptions}
                            placeholder="Select City"
                            isClearable
                        />
                    </div>

                    <div className="col-md-6">
                        <label className="form-label">Email</label>
                        <input
                            className="form-control"
                            type="email"
                            value={userData.email}
                            name="email"
                            onChange={handleChange}
                            placeholder="Enter email (optional)"
                        />
                    </div>

                    <div className="col-md-6">
                        <label className="form-label">Role <span className="text-danger">*</span></label>
                        <select
                            className="form-control"
                            name="role"
                            value={userData.role}
                            onChange={handleRoleChange}
                            required
                        >
                            <option value="user">User</option>
                            <option value="admin">Admin</option>
                        </select>
                    </div>

                    <div className="col-md-6">
                        <label className="form-label">Status <span className="text-danger">*</span></label>
                        <select
                            className="form-control"
                            name="status"
                            value={userData.status}
                            onChange={handleStatusChange}
                            required
                        >
                            <option value="1">Active</option>
                            <option value="0">Inactive</option>
                        </select>
                    </div>

                    <div className="col-md-6">
                        <label className="form-label">Password <span className="text-danger">*</span></label>
                        <input
                            className="form-control"
                            type="password"
                            value={userData.password}
                            name="password"
                            onChange={handleChange}
                            placeholder="Enter password (min 6 characters)"
                            minLength="6"
                            required
                        />
                    </div>

                    <div className="col-md-6">
                        <label className="form-label">Confirm Password <span className="text-danger">*</span></label>
                        <input
                            className="form-control"
                            type="password"
                            value={confirmPassword}
                            onChange={(e) => setConfirmPassword(e.target.value)}
                            placeholder="Confirm password"
                            minLength="6"
                            required
                        />
                    </div>

                    <div className="col-12">
                        <button
                            className="btn btn-primary btn-lg"
                            onClick={handleCreate}
                            disabled={loading}
                        >
                            {loading ? 'Loading...' : 'Submit'}
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default UserCreate;
